import { render, staticRenderFns } from "./OrderPriceMatch.vue?vue&type=template&id=add1eaf8"
import script from "./OrderPriceMatch.vue?vue&type=script&lang=js"
export * from "./OrderPriceMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports